import Filter from "core/filtering/filter";

export default class BroadcastFilter extends Filter {
    constructor() {
        super({ $orderby: "SentDate desc" });
    }
}
